import ConnectedAccountsFull from './components/ConnectedAccountsFull';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { connectedAccountsStore } from './store/store';
import { onDiscardConnectedAccountOption } from './orchestrators/onDiscardConnectedAccountOption';
import { onSaveConnectedAccountOption } from './orchestrators/onSaveConnectedAccountOption';
import { isFeatureEnabled } from 'owa-feature-flags';

const ConnectedAccountsOption: Option = {
    key: 'connected',
    titleStringKey: 'optionTitle_connected',
    searchTermsStringKey: 'optionTitle_connected',
    fullOptionFormSettings: {
        render: () => <ConnectedAccountsFull />,
        isDirty: () =>
            connectedAccountsStore().isConnectedAccountsDirty ||
            connectedAccountsStore().isDefaultFromDirty,
        onSave: onSaveConnectedAccountOption,
        onDiscard: onDiscardConnectedAccountOption,
    },
    isHidden: () => !isFeatureEnabled('auth-connectedAccounts'),
    allowedOptionKeys: ['AttachmentConnectedAccounts', 'ConnectedAccounts'],
};

export default ConnectedAccountsOption;
